webpackJsonp([1],{

/***/ "+5a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thread-list"},[_c('h2',{staticClass:"list-title"},[_vm._v("Threads")]),_vm._v(" "),_vm._l((_vm.threads),function(thread){return _c('ThreadListItem',{key:thread['.key'],attrs:{"thread":thread}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+QwA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+i8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid justify-center"},[_c('div',{staticClass:"col-2"},[_c('form',{staticClass:"card card-form",on:{"submit":function($event){$event.preventDefault();_vm.signIn($event)}}},[_c('h1',{staticClass:"text-center"},[_vm._v("Login")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-input",attrs:{"id":"email","type":"text"},domProps:{"value":(_vm.form.email)},on:{"blur":function($event){_vm.$v.form.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.email.$error)?[(!_vm.$v.form.email.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):(!_vm.$v.form.email.email)?_c('span',{staticClass:"form-error"},[_vm._v("This in not a valid email address")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-input",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"blur":function($event){_vm.$v.form.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.password.$error)?[(!_vm.$v.form.password.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.password.minLength)?_c('span',{staticClass:"form-error"},[_vm._v("The password must be at least 6 characters long")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-actions text-right"},[_c('router-link',{attrs:{"to":{name: 'Register'}}},[_vm._v("Create an account?")])],1)]),_vm._v(" "),_c('div',{staticClass:"push-top text-center"},[_c('button',{staticClass:"btn-red btn-xsmall",on:{"click":_vm.signInWithGoogle}},[_c('i',{staticClass:"fa fa-google fa-btn"}),_vm._v("Sign in with Google")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-top"},[_c('button',{staticClass:"btn-blue btn-block",attrs:{"type":"submit"}},[_vm._v("Log in")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/7IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validators__ = __webpack_require__("XWRh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      required: true,
      type: Object
    }
  },

  data: function data() {
    return {
      activeUser: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.user)
    };
  },


  computed: {
    userThreadsCount: function userThreadsCount() {
      return this.$store.getters['users/userThreadsCount'](this.user['.key']);
    },
    userPostsCount: function userPostsCount() {
      return this.$store.getters['users/userPostsCount'](this.user['.key']);
    }
  },

  validations: {
    activeUser: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      username: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        unique: function unique(value) {
          if (value.toLowerCase() === this.user.usernameLower) {
            return true;
          }
          return Object(__WEBPACK_IMPORTED_MODULE_2__utils_validators__["d" /* uniqueUsername */])(value);
        }
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"],
        unique: function unique(value) {
          if (value.toLowerCase() === this.user.email) {
            return true;
          }
          return Object(__WEBPACK_IMPORTED_MODULE_2__utils_validators__["c" /* uniqueEmail */])(value);
        }
      }
    }
  },

  methods: {
    save: function save() {
      this.$v.activeUser.$touch();
      if (!this.$v.activeUser.$invalid) {
        this.$store.dispatch('users/updateUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.activeUser));
        this.$router.push({ name: 'Profile' });
      }
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Profile' });
    }
  }
});

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countObjectProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeEmptyProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



var countObjectProperties = function countObjectProperties(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).length;
  }
  return 0;
};

var removeEmptyProperties = function removeEmptyProperties(obj) {
  var objCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(objCopy).forEach(function (key) {
    if ([null, undefined].includes(objCopy[key])) {
      delete objCopy[key];
    }
  });
  return objCopy;
};



/***/ }),

/***/ "137Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCard_vue__ = __webpack_require__("Iq3c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0852591d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCard_vue__ = __webpack_require__("CYjo");
function injectStyle (ssrContext) {
  __webpack_require__("9jCt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0852591d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0852591d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1U+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Welcome to the Forum")]),_vm._v(" "),_c('CategoryList',{attrs:{"categories":_vm.categories}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "20wD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "28xs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3 push-top"},[_c('div',{staticClass:"profile-card"},[_c('p',{staticClass:"text-center"},[_c('img',{staticClass:"avatar-xlarge img-update",attrs:{"src":_vm.user.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.activeUser.username),expression:"activeUser.username",modifiers:{"lazy":true}}],staticClass:"form-input text-lead text-bold",attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.activeUser.username)},on:{"blur":function($event){_vm.$v.activeUser.username.$touch()},"change":function($event){_vm.$set(_vm.activeUser, "username", $event.target.value)}}}),_vm._v(" "),(_vm.$v.activeUser.username.$error)?[(!_vm.$v.activeUser.username.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.activeUser.username.unique)?_c('span',{staticClass:"form-error"},[_vm._v("Sorry! This username is taken")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.name),expression:"activeUser.name"}],staticClass:"form-input text-lead",attrs:{"type":"text","placeholder":"Full Name"},domProps:{"value":(_vm.activeUser.name)},on:{"blur":function($event){_vm.$v.activeUser.name.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "name", $event.target.value)}}}),_vm._v(" "),(_vm.$v.activeUser.name.$error)?[(!_vm.$v.activeUser.name.required)?_c('span',{staticClass:"form-error"},[_vm._v("The name field is required")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"user_bio"}},[_vm._v("Bio")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.bio),expression:"activeUser.bio"}],staticClass:"form-input",attrs:{"id":"user_bio","placeholder":"Write a few words about yourself."},domProps:{"value":(_vm.activeUser.bio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "bio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('span',[_vm._v(_vm._s(_vm.userPostsCount)+" posts")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userThreadsCount)+" threads")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label",attrs:{"for":"user_website"}},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.website),expression:"activeUser.website"}],staticClass:"form-input",attrs:{"autocomplete":"off","id":"user_website"},domProps:{"value":(_vm.activeUser.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "website", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label",attrs:{"for":"user_email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.activeUser.email),expression:"activeUser.email",modifiers:{"lazy":true}}],staticClass:"form-input",attrs:{"autocomplete":"off","id":"user_email"},domProps:{"value":(_vm.activeUser.email)},on:{"blur":function($event){_vm.$v.activeUser.email.$touch()},"change":function($event){_vm.$set(_vm.activeUser, "email", $event.target.value)}}}),_vm._v(" "),(_vm.$v.activeUser.email.$error)?[(!_vm.$v.activeUser.email.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):(!_vm.$v.activeUser.email.email)?_c('span',{staticClass:"form-error"},[_vm._v("This in not a valid email address")]):(!_vm.$v.activeUser.email.unique)?_c('span',{staticClass:"form-error"},[_vm._v("Sorry! This email is taken")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label",attrs:{"for":"user_location"}},[_vm._v("Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeUser.location),expression:"activeUser.location"}],staticClass:"form-input",attrs:{"autocomplete":"off","id":"user_location"},domProps:{"value":(_vm.activeUser.location)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.activeUser, "location", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group space-between"},[_c('button',{staticClass:"btn-ghost",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn-blue",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.save($event)}}},[_vm._v("Save")])])]),_vm._v(" "),_c('p',{staticClass:"text-xsmall text-faded text-center"},[_vm._v("Member since june 2003, last visited 4 hours ago")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2IqW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Puu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ZPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadEdit_vue__ = __webpack_require__("awId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6a29d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadEdit_vue__ = __webpack_require__("I/aD");
function injectStyle (ssrContext) {
  __webpack_require__("8Zi6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c6a29d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6a29d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2aZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      asyncDataStatus_ready: false
    };
  },


  methods: {
    asyncDataStatus_fetched: function asyncDataStatus_fetched() {
      this.asyncDataStatus_ready = true;
      this.$emit('ready');
    }
  }
});

/***/ }),

/***/ "2ho9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMobileNavbar),expression:"closeMobileNavbar"},{name:"handle-scroll",rawName:"v-handle-scroll",value:(_vm.closeMobileNavbar),expression:"closeMobileNavbar"}],staticClass:"header",attrs:{"id":"header"}},[_c('router-link',{staticClass:"logo",attrs:{"to":{name: 'Home'}}},[_c('img',{attrs:{"src":__webpack_require__("3Y6K")}})]),_vm._v(" "),_c('div',{staticClass:"btn-hamburger",on:{"click":function($event){_vm.mobileNavOpen = !_vm.mobileNavOpen}}},[_c('div',{staticClass:"top bar"}),_vm._v(" "),_c('div',{staticClass:"middle bar"}),_vm._v(" "),_c('div',{staticClass:"bottom bar"})]),_vm._v(" "),_c('nav',{staticClass:"navbar",class:{'navbar-open': _vm.mobileNavOpen}},[(_vm.user)?_c('ul',[_c('li',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeUserDropdown),expression:"closeUserDropdown"}],staticClass:"navbar-user"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.userDropdownOpen = !_vm.userDropdownOpen}}},[_c('img',{staticClass:"avatar-small",attrs:{"src":_vm.user.avatar,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.user.name)+"\n              "),_c('img',{staticClass:"icon-profile",attrs:{"src":__webpack_require__("lSiE"),"alt":""}})])]),_vm._v(" "),_c('div',{class:{'active-drop': _vm.userDropdownOpen},attrs:{"id":"user-dropdown"}},[_c('div',{staticClass:"triangle-drop"}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"dropdown-menu-item"},[_c('router-link',{attrs:{"to":{name: 'Profile'}}},[_vm._v("View Profile")])],1),_vm._v(" "),_c('li',{staticClass:"dropdown-menu-item"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.$store.dispatch('auth/signOut')}}},[_vm._v("Sign Out")])])])])]),_vm._v(" "),_c('li',{staticClass:"navbar-mobile-item"},[_c('router-link',{attrs:{"to":{name: 'Profile'}}},[_vm._v("View Profile")])],1),_vm._v(" "),_c('li',{staticClass:"navbar-mobile-item"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.$store.dispatch('auth/signOut')}}},[_vm._v("Sign Out")])])]):_c('ul',[_c('li',{staticClass:"navbar-item"},[_c('router-link',{attrs:{"to":{name: 'SignIn'}}},[_vm._v("Sign In")])],1),_vm._v(" "),_c('li',{staticClass:"navbar-item"},[_c('router-link',{attrs:{"to":{name: 'Register'}}},[_vm._v("Register")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Y6K":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjExMi42IC0yNDcuNSA0MCA0NSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAxMTIuNiAtMjQ3LjUgNDAgNDUiIHhtbDpzcGFjZT0icHJlc2VydmUiPgoJPGc+CgkJCQk8ZyBpZD0iTGF5ZXJfMTQiPgoJCQkJCTxwYXRoIGZpbGw9IiNGRjY2QzgiIGQ9Ik0xNDIuOC0yMzkuN2MwLDAsMC44LTEuNCwyLjMtMC43YzEuNSwwLjcsNi4xLDIuNyw2LjEsMi43czIuMSwwLjcsMS4yLDIuOGMtMC43LDEuNS0yLjcsNi4yLTIuNyw2LjIKCQkJCQkJbC05LjYtNC42TDE0Mi44LTIzOS43TDE0Mi44LTIzOS43eiIvPgoJCQkJPC9nPgoJCQkJPGcgaWQ9IkxheWVyXzExIj4KCQkJCQk8cGF0aCBmaWxsPSIjRDJEOEQ1IiBkPSJNMTQwLjctMjM0LjdsMi42LDEuOGwzLjcsMS42bDMuNSwwLjdsLTEuOSw0LjFjMCwwLTguOCw2LjUtOS43LTQuMkwxNDAuNy0yMzQuN0wxNDAuNy0yMzQuN3oiLz4KCQkJCTwvZz4KCQkJCTxnIGlkPSJMYXllcl84Ij4KCQkJCQk8cG9seWdvbiBmaWxsPSIjMTU3QTRBIiBwb2ludHM9IjE0OS40LC0yMjguMiAxNDUuOSwtMjI5IDE0Mi4yLC0yMzAuNiAxMzkuNywtMjMyLjQgMTI5LC0yMDguMiAxMzgsLTIwMi42IAkJIi8+CgkJCQk8L2c+CgkJCQk8ZyBpZD0iTGF5ZXJfMSI+CgkJCQkJPHBvbHlnb24gZmlsbD0iIzIyQjU3MyIgcG9pbnRzPSIxMzgsLTIwMi41IDEyNS4zLC0yMDIuNSAxMTIuNiwtMjM0LjIgMTIzLjUsLTIzOC43IAkJIi8+CgkJCQk8L2c+CgkJCQk8ZyBpZD0iTGF5ZXJfMiI+CgkJCQkJPHBhdGggZmlsbD0iI0ZGREFBRSIgZD0iTTExMi42LTIzNC4ybDEuMi0xMy4ybDkuNyw4LjdjMCwwLTEuNywyLjItMy44LDEuNmMwLDAtMC45LDEuOS0zLjQsMS40CgkJCQkJCUMxMTYuMy0yMzUuOCwxMTUuMS0yMzMuNCwxMTIuNi0yMzQuMnoiLz4KCQkJCTwvZz4KCQkJCTxnIGlkPSJMYXllcl83Ij4KCQkJCQk8cGF0aCBkPSJNMTE1LjEtMjQ2LjNsLTEuMy0xLjJsLTAuMywzLjJjMC4xLDAsMS44LTAuNCwyLjUtMS4yQzExNi0yNDUuNSwxMTUuMS0yNDYuMywxMTUuMS0yNDYuM3oiLz4KCQkJCTwvZz4KCQkJCTwvZz4KPC9zdmc+"

/***/ }),

/***/ "3YjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ForumList__ = __webpack_require__("RxF9");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ForumList: __WEBPACK_IMPORTED_MODULE_1__ForumList__["a" /* default */]
  },

  props: {
    category: {
      required: true,
      type: Object
    }
  },

  computed: {
    categoryForums: function categoryForums() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.state.forums.items).filter(function (forum) {
        return forum.categoryId === _this.category['.key'];
      });
    }
  }
});

/***/ }),

/***/ "3kGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadCreate_vue__ = __webpack_require__("PtMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_809f6ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadCreate_vue__ = __webpack_require__("Iufq");
function injectStyle (ssrContext) {
  __webpack_require__("ZvBy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-809f6ff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_809f6ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5CYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__("VgQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccc9e55e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__("G4OZ");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("Vb7x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccc9e55e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Ap8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    forum: {
      required: true,
      type: Object
    }
  },

  computed: {
    threadsCount: function threadsCount() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* countObjectProperties */])(this.forum.threads);
    }
  }
});

/***/ }),

/***/ "6blT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumListItem_vue__ = __webpack_require__("6Ap8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751bee61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumListItem_vue__ = __webpack_require__("9WDL");
function injectStyle (ssrContext) {
  __webpack_require__("CO6B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-751bee61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751bee61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7n+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeAppendChildToParentMutation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var makeAppendChildToParentMutation = function makeAppendChildToParentMutation(_ref) {
  var parent = _ref.parent,
      child = _ref.child;
  return function (state, _ref2) {
    var childId = _ref2.childId,
        parentId = _ref2.parentId;

    var resource = state.items[parentId];
    if (!resource[child]) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(resource, child, {});
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(resource[child], childId, childId);
  };
};

/***/ }),

/***/ "88+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TheNavbar'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}],key:_vm.$route.path,on:{"ready":_vm.pageReady}}),_vm._v(" "),_c('AppSpinner',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPage),expression:"!showPage"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Zi6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "91W5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavbar_vue__ = __webpack_require__("nJYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b96f130_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavbar_vue__ = __webpack_require__("2ho9");
function injectStyle (ssrContext) {
  __webpack_require__("DLOc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b96f130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b96f130_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9WDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum-listing"},[_c('div',{staticClass:"forum-details"},[_c('router-link',{staticClass:"text-xlarge",attrs:{"to":{name: 'Forum', params: {id: _vm.forum['.key']}}}},[_vm._v("\n      "+_vm._s(_vm.forum.name)+"\n    ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forum.description))])],1),_vm._v(" "),_c('div',{staticClass:"threads-count"},[_c('p',{staticClass:"count"},[_vm._v(_vm._s(_vm.threadsCount))]),_vm._v("\n    "+_vm._s(_vm.threadsCount === 1 ? 'thread' : 'threads')+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"last-thread"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9jCt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9oCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ForumListItem__ = __webpack_require__("6blT");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ForumListItem: __WEBPACK_IMPORTED_MODULE_0__ForumListItem__["a" /* default */]
  },

  props: {
    forums: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "BXD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    fetchAllCategories: function fetchAllCategories(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      console.log('🔥', '🏷', 'all');
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('categories').once('value', function (snapshot) {
          var categoriesObject = snapshot.val();
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(categoriesObject).forEach(function (categoryId) {
            var category = categoriesObject[categoryId];
            commit('setItem', { resource: 'categories', id: categoryId, item: category }, { root: true });
          });
          resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.items));
        });
      });
    },


    fetchCategory: function fetchCategory(_ref2, _ref3) {
      var dispatch = _ref2.dispatch;
      var id = _ref3.id;
      return dispatch('fetchItem', { resource: 'categories', id: id, emoji: '🏷' }, { root: true });
    },
    fetchCategories: function fetchCategories(_ref4, _ref5) {
      var dispatch = _ref4.dispatch;
      var ids = _ref5.ids;
      return dispatch('fetchItems', { resource: 'categories', ids: ids, emoji: '🏷' }, { root: true });
    }
  }
});

/***/ }),

/***/ "BigJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum-list"},[_c('h2',{staticClass:"list-title"},[_c('router-link',{attrs:{"to":{name: 'Category', params: {id: _vm.category['.key']}}}},[_vm._v("\n      "+_vm._s(_vm.category.name)+"\n    ")])],1),_vm._v(" "),_c('ForumList',{attrs:{"forums":_vm.categoryForums}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C4Cl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_assetHelpers__ = __webpack_require__("7n+g");







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    items: {}
  },

  getters: {
    threadRepliesCount: function threadRepliesCount(state) {
      return function (id) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* countObjectProperties */])(state.items[id].posts) - 1;
      };
    }
  },

  actions: {
    createThread: function createThread(_ref, _ref2) {
      var state = _ref.state,
          commit = _ref.commit,
          dispatch = _ref.dispatch,
          rootState = _ref.rootState;
      var text = _ref2.text,
          title = _ref2.title,
          forumId = _ref2.forumId;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var threadId = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('threads').push().key;
        var postId = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('posts').push().key;
        var userId = rootState.auth.authId;
        var publishedAt = Math.floor(Date.now() / 1000);

        var thread = { title: title, forumId: forumId, publishedAt: publishedAt, userId: userId, firstPostId: postId, posts: {} };
        thread.posts[postId] = postId;
        var post = { text: text, publishedAt: publishedAt, threadId: threadId, userId: userId };

        var updates = {};
        updates['threads/' + threadId] = thread;
        updates['forums/' + forumId + '/threads/' + threadId] = threadId;
        updates['users/' + userId + '/threads/' + threadId] = threadId;

        updates['posts/' + postId] = post;
        updates['users/' + userId + '/posts/' + postId] = postId;
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref().update(updates).then(function () {
          // update thread
          commit('setItem', { resource: 'threads', id: threadId, item: thread }, { root: true });
          commit('forums/appendThreadToForum', { parentId: forumId, childId: threadId }, { root: true });
          commit('users/appendThreadToUser', { parentId: userId, childId: threadId }, { root: true });
          // update post
          commit('setItem', { resource: 'posts', item: post, id: postId }, { root: true });
          commit('appendPostToThread', { parentId: post.threadId, childId: postId });
          commit('users/appendPostToUser', { parentId: post.userId, childId: postId }, { root: true });

          resolve(state.items[threadId]);
        });
      });
    },
    updateThread: function updateThread(_ref3, _ref4) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          rootState = _ref3.rootState;
      var title = _ref4.title,
          text = _ref4.text,
          id = _ref4.id;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var thread = state.items[id];
        var post = rootState.posts.items[thread.firstPostId];

        var edited = {
          at: Math.floor(Date.now() / 1000),
          by: rootState.auth.authId
        };

        var updates = {};
        updates['posts/' + thread.firstPostId + '/text'] = text;
        updates['posts/' + thread.firstPostId + '/edited'] = edited;
        updates['threads/' + id + '/title'] = title;

        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref().update(updates).then(function () {
          commit('setThread', { thread: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, thread, { title: title }), threadId: id });
          commit('posts/setPost', { postId: thread.firstPostId, post: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, post, { text: text, edited: edited }) }, { root: true });
          resolve(post);
        });
      });
    },

    fetchThread: function fetchThread(_ref5, _ref6) {
      var dispatch = _ref5.dispatch;
      var id = _ref6.id;
      return dispatch('fetchItem', { resource: 'threads', id: id, emoji: '📄' }, { root: true });
    },
    fetchThreads: function fetchThreads(_ref7, _ref8) {
      var dispatch = _ref7.dispatch;
      var ids = _ref8.ids;
      return dispatch('fetchItems', { resource: 'threads', ids: ids, emoji: '🌧' }, { root: true });
    }
  },
  mutations: {
    setThread: function setThread(state, _ref9) {
      var thread = _ref9.thread,
          threadId = _ref9.threadId;

      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.items, threadId, thread);
    },


    appendPostToThread: Object(__WEBPACK_IMPORTED_MODULE_5__store_assetHelpers__["a" /* makeAppendChildToParentMutation */])({ parent: 'threads', child: 'posts' }),
    appendContributorToThread: Object(__WEBPACK_IMPORTED_MODULE_5__store_assetHelpers__["a" /* makeAppendChildToParentMutation */])({ parent: 'threads', child: 'contributors' })
  }
});

/***/ }),

/***/ "CO6B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "COEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadList_vue__ = __webpack_require__("iy9d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4f6c09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__ = __webpack_require__("+5a1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4f6c09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CYjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-3 push-top"},[_c('div',{staticClass:"profile-card"},[_c('p',{staticClass:"text-center"},[_c('img',{staticClass:"avatar-xlarge",attrs:{"src":_vm.user.avatar,"alt":""}})]),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.user.username))]),_vm._v(" "),_c('p',{staticClass:"text-lead"},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('p',{staticClass:"text-justify"},[(_vm.user.bio)?_c('span',[_vm._v(_vm._s(_vm.user.bio))]):_c('span',[_vm._v("No bio specified.")])]),_vm._v(" "),_c('span',{staticClass:"online"},[_vm._v(_vm._s(_vm.user.username)+" is online")]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('span',[_vm._v(_vm._s(_vm.userPostsCount)+" posts")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userThreadsCount)+" threads")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.user.website)?_c('p',{staticClass:"text-large text-center"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.user.website}},[_vm._v(_vm._s(_vm.user.website))])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"text-xsmall text-faded text-center"},[_vm._v("Member since june 2003, last visited 4 hours ago")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('hr'),_vm._v(" "),_c('router-link',{staticClass:"btn-green btn-small",attrs:{"to":{name: 'ProfileEdit'}}},[_vm._v("\n      Edit Profile\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ClcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppDate_vue__ = __webpack_require__("rQVF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4fd17e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppDate_vue__ = __webpack_require__("PIx/");
function injectStyle (ssrContext) {
  __webpack_require__("igFY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d4fd17e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4fd17e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ct2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadShow_vue__ = __webpack_require__("UDeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761ba689_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadShow_vue__ = __webpack_require__("W9X7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageThreadShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761ba689_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageThreadShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    authId: null,
    unsubscribeAuthObserver: null
  },

  getters: {
    authUser: function authUser(state, getters, rootState) {
      return state.authId ? rootState.users.items[state.authId] : null;
    }
  },

  actions: {
    initAuthentication: function initAuthentication(_ref) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // unsubscribe observer if already listening
        if (state.unsubscribeAuthObserver) {
          state.unsubscribeAuthObserver();
        }

        var unsubscribe = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().onAuthStateChanged(function (user) {
          console.log('👣 the user has changed');
          if (user) {
            dispatch('fetchAuthUser').then(function (dbUser) {
              return resolve(dbUser);
            });
          } else {
            resolve(null);
          }
        });
        commit('setUnsubscribeAuthObserver', unsubscribe);
      });
    },
    registerUserWithEmailAndPassword: function registerUserWithEmailAndPassword(_ref2, _ref3) {
      var dispatch = _ref2.dispatch;
      var email = _ref3.email,
          name = _ref3.name,
          username = _ref3.username,
          password = _ref3.password,
          _ref3$avatar = _ref3.avatar,
          avatar = _ref3$avatar === undefined ? null : _ref3$avatar;

      return __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().createUserWithEmailAndPassword(email, password).then(function (user) {
        return dispatch('users/createUser', { id: user.uid, email: email, name: name, username: username, password: password, avatar: avatar }, { root: true });
      }).then(function () {
        return dispatch('fetchAuthUser');
      });
    },
    signInWithEmailAndPassword: function signInWithEmailAndPassword(context, _ref4) {
      var email = _ref4.email,
          password = _ref4.password;

      return __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithEmailAndPassword(email, password);
    },
    signInWithGoogle: function signInWithGoogle(_ref5) {
      var dispatch = _ref5.dispatch;

      var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth.GoogleAuthProvider();
      return __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithPopup(provider).then(function (data) {
        var user = data.user;
        __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users').child(user.uid).once('value', function (snapshot) {
          if (!snapshot.exists()) {
            return dispatch('users/createUser', { id: user.uid, name: user.displayName, email: user.email, username: user.email, avatar: user.photoURL }, { root: true }).then(function () {
              return dispatch('fetchAuthUser');
            });
          }
        });
      });
    },
    signOut: function signOut(_ref6) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {
        commit('setAuthId', null);
      });
    },
    fetchAuthUser: function fetchAuthUser(_ref7) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;

      var userId = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // check if user exists in the database
        __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users').child(userId).once('value', function (snapshot) {
          if (snapshot.exists()) {
            return dispatch('users/fetchUser', { id: userId }, { root: true }).then(function (user) {
              commit('setAuthId', userId);
              resolve(user);
            });
          } else {
            resolve(null);
          }
        });
      });
    }
  },

  mutations: {
    setAuthId: function setAuthId(state, id) {
      state.authId = id;
    },
    setUnsubscribeAuthObserver: function setUnsubscribeAuthObserver(state, unsubscribe) {
      state.unsubscribeAuthObserver = unsubscribe;
    }
  }
});

/***/ }),

/***/ "DLOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DMjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DeYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostList_vue__ = __webpack_require__("b4MN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_251fd6df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostList_vue__ = __webpack_require__("HZ0X");
function injectStyle (ssrContext) {
  __webpack_require__("YJf6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-251fd6df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_251fd6df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Eu5h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FLwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid"},[(!_vm.edit)?_c('UserProfileCard',{attrs:{"user":_vm.user}}):_c('UserProfileCardEditor',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('div',{staticClass:"col-7 push-top"},[_c('div',{staticClass:"profile-header"},[_c('span',{staticClass:"text-lead"},[_vm._v("\n          "+_vm._s(_vm.user.username)+"'s recent activity\n      ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_vm._v("See only started threads?")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('PostList',{attrs:{"posts":_vm.userPosts}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G4OZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-full",class:_vm.$style.centered},[_c('h1',{class:_vm.$style.headingLarge},[_vm._v("Not Found")]),_vm._v(" "),_c('p',{staticClass:"text-large",class:_vm.$style.textLarge},[_vm._v("\n    Ooops, we couldn't find what you are looking for. Why don't you\n    "),_c('router-link',{attrs:{"to":{name: 'Home'}}},[_vm._v("\n      go home instead?\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H2uP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full"},[_c('h1',[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),_c('CategoryListItem',{attrs:{"category":_vm.category}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HZ0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-list"},_vm._l((_vm.posts),function(post){return _c('PostListItem',{key:post['.key'],attrs:{"post":post}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HcPj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I/aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Editing "),_c('i',[_vm._v(_vm._s(_vm.thread.title))])]),_vm._v(" "),_c('ThreadEditor',{ref:"editor",attrs:{"title":_vm.thread.title,"text":_vm.text},on:{"save":_vm.save,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_categories__ = __webpack_require__("BXD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_forums__ = __webpack_require__("upVr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_threads__ = __webpack_require__("C4Cl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_posts__ = __webpack_require__("QSQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_users__ = __webpack_require__("xSZb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_auth__ = __webpack_require__("D+VX");












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  modules: {
    categories: __WEBPACK_IMPORTED_MODULE_5__modules_categories__["a" /* default */],
    forums: __WEBPACK_IMPORTED_MODULE_6__modules_forums__["a" /* default */],
    threads: __WEBPACK_IMPORTED_MODULE_7__modules_threads__["a" /* default */],
    posts: __WEBPACK_IMPORTED_MODULE_8__modules_posts__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_9__modules_users__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_10__modules_auth__["a" /* default */]
  }
}));

/***/ }),

/***/ "Iq3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      required: true,
      type: Object
    }
  },

  computed: {
    userThreadsCount: function userThreadsCount() {
      return this.$store.getters['users/userThreadsCount'](this.user['.key']);
    },
    userPostsCount: function userPostsCount() {
      return this.$store.getters['users/userPostsCount'](this.user['.key']);
    }
  }
});

/***/ }),

/***/ "IqJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostEditor__ = __webpack_require__("TJYQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    post: {
      required: true,
      type: Object
    }
  },

  components: {
    PostEditor: __WEBPACK_IMPORTED_MODULE_0__PostEditor__["a" /* default */]
  },

  data: function data() {
    return {
      editing: false
    };
  },


  computed: {
    user: function user() {
      return this.$store.state.users.items[this.post.userId];
    },
    userPostsCount: function userPostsCount() {
      return this.$store.getters['users/userPostsCount'](this.post.userId);
    },
    userThreadsCount: function userThreadsCount() {
      return this.$store.getters['users/userThreadsCount'](this.post.userId);
    }
  }
});

/***/ }),

/***/ "Iufq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Create new thread in "),_c('i',[_vm._v(_vm._s(_vm.forum.name))])]),_vm._v(" "),_c('ThreadEditor',{ref:"editor",on:{"save":_vm.save,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JIjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post && _vm.user)?_c('div',{staticClass:"post"},[_c('div',{staticClass:"user-info"},[_c('a',{staticClass:"user-name",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{staticClass:"avatar-large",attrs:{"src":_vm.user.avatar,"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"desktop-only text-small"},[_vm._v(_vm._s(_vm.userThreadsCount)+" threads")]),_vm._v(" "),_c('p',{staticClass:"desktop-only text-small"},[_vm._v(_vm._s(_vm.userPostsCount)+" posts")])]),_vm._v(" "),_c('div',{staticClass:"post-content"},[(!_vm.editing)?[_c('div',[_vm._v("\n        "+_vm._s(_vm.post.text)+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"link-unstyled",staticStyle:{"margin-left":"auto"},attrs:{"href":"#","title":"Make a change"},on:{"click":function($event){$event.preventDefault();_vm.editing = true}}},[_c('i',{staticClass:"fa fa-pencil"})])]:_c('div',[_c('PostEditor',{attrs:{"post":_vm.post},on:{"save":function($event){_vm.editing = false},"cancel":function($event){_vm.editing = false}}})],1)],2),_vm._v(" "),_c('div',{staticClass:"post-date text-faded"},[(_vm.post.edited)?_c('div',{staticClass:"edition-info"},[_vm._v("edited")]):_vm._e(),_vm._v(" "),_c('AppDate',{attrs:{"timestamp":_vm.post.publishedAt}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JX7A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JiM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.save($event)}}},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"form-input",attrs:{"name":"","id":"","cols":"30","rows":"10"},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[(_vm.isUpdate)?_c('button',{staticClass:"btn btn-ghost",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-blue"},[_vm._v(_vm._s(_vm.isUpdate ? 'Update' : 'Submit post'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kagk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be00b89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("88+F");
function injectStyle (ssrContext) {
  __webpack_require__("JX7A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be00b89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MzKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CategoryListItem__ = __webpack_require__("u7GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CategoryListItem: __WEBPACK_IMPORTED_MODULE_2__components_CategoryListItem__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__["a" /* default */]],

  props: {
    id: {
      required: true,
      type: String
    }
  },

  computed: {
    category: function category() {
      return this.$store.state.categories.items[this.id];
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('categories', ['fetchCategory']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('forums', ['fetchForums'])),

  created: function created() {
    var _this = this;

    this.fetchCategory({ id: this.id }).then(function (category) {
      return _this.fetchForums({ ids: category.forums });
    }).then(function () {
      _this.asyncDataStatus_fetched();
    });
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppDate__ = __webpack_require__("ClcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('AppDate', __WEBPACK_IMPORTED_MODULE_5__components_AppDate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Initialize Firebase
var config = {
  apiKey: "AIzaSyCSeQuzX4pW0DEKQiDUC_t4ityiidc6nA0",
  authDomain: "amgando-school-forum.firebaseapp.com",
  databaseURL: "https://amgando-school-forum-default-rtdb.firebaseio.com",
  projectId: "amgando-school-forum",
  storageBucket: "amgando-school-forum.appspot.com",
  messagingSenderId: "967524801411"
};
__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.initializeApp(config);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NMPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      form: {
        title: this.title,
        text: this.text
      }
    };
  },


  validations: {
    form: {
      title: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(10)
      },
      text: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(40)
      }
    }
  },

  computed: {
    isUpdate: function isUpdate() {
      return !!this.title;
    }
  },

  methods: {
    save: function save() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.$emit('save', { title: this.form.title, text: this.form.text });
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "OGiz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    el.__HandleScrollHandler__ = function (event) {
      return binding.value(event);
    };
    document.body.addEventListener('mousewheel', el.__HandleScrollHandler__);
    document.body.addEventListener('touchmove', el.__HandleScrollHandler__);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('mousewheel', el.__HandleScrollHandler__);
    document.body.removeEventListener('touchmove', el.__HandleScrollHandler__);
  }
});

/***/ }),

/***/ "PIx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm._f("humanFriendlyDate")(_vm.timestamp)}},[_vm._v(_vm._s(_vm._f("diffForHumans")(_vm.timestamp)))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PtMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__ = __webpack_require__("wEhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadEditor: __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__["a" /* default */]],

  props: {
    forumId: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      saved: false
    };
  },


  computed: {
    forum: function forum() {
      return this.$store.state.forums.items[this.forumId];
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      return (this.$refs.editor.form.title || this.$refs.editor.form.text) && !this.saved;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('threads', ['createThread']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('forums', ['fetchForum']), {
    save: function save(_ref) {
      var _this = this;

      var title = _ref.title,
          text = _ref.text;

      this.createThread({
        forumId: this.forum['.key'],
        title: title,
        text: text
      }).then(function (thread) {
        _this.saved = true;
        _this.$router.push({ name: 'ThreadShow', params: { id: thread['.key'] } });
      });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Forum', params: { id: this.forum['.key'] } });
    }
  }),

  created: function created() {
    var _this2 = this;

    this.fetchForum({ id: this.forumId }).then(function () {
      _this2.asyncDataStatus_fetched();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      var confirmed = window.confirm('Are you sure you want to leave? Unsaved changes will be lost.');
      if (confirmed) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "QSQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    createPost: function createPost(_ref, post) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      var postId = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('posts').push().key;
      post.userId = rootState.auth.authId;
      post.publishedAt = Math.floor(Date.now() / 1000);

      var updates = {};
      updates['posts/' + postId] = post;
      updates['threads/' + post.threadId + '/posts/' + postId] = postId;
      updates['threads/' + post.threadId + '/contributors/' + post.userId] = post.userId;
      updates['users/' + post.userId + '/posts/' + postId] = postId;
      __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref().update(updates).then(function () {
        commit('setItem', { resource: 'posts', item: post, id: postId }, { root: true });
        commit('threads/appendPostToThread', { parentId: post.threadId, childId: postId }, { root: true });
        commit('threads/appendContributorToThread', { parentId: post.threadId, childId: post.userId }, { root: true });
        commit('users/appendPostToUser', { parentId: post.userId, childId: postId }, { root: true });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.items[postId]);
      });
    },
    updatePost: function updatePost(_ref2, _ref3) {
      var state = _ref2.state,
          commit = _ref2.commit,
          rootState = _ref2.rootState;
      var id = _ref3.id,
          text = _ref3.text;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var post = state.items[id];
        var edited = {
          at: Math.floor(Date.now() / 1000),
          by: rootState.auth.authId
        };

        var updates = { text: text, edited: edited };
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('posts').child(id).update(updates).then(function () {
          commit('setPost', { postId: id, post: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, post, { text: text, edited: edited }) });
          resolve(post);
        });
      });
    },


    fetchPost: function fetchPost(_ref4, _ref5) {
      var dispatch = _ref4.dispatch;
      var id = _ref5.id;
      return dispatch('fetchItem', { resource: 'posts', id: id, emoji: '💬' }, { root: true });
    },
    fetchPosts: function fetchPosts(_ref6, _ref7) {
      var dispatch = _ref6.dispatch;
      var ids = _ref7.ids;
      return dispatch('fetchItems', { resource: 'posts', ids: ids, emoji: '💬' }, { root: true });
    }
  },

  mutations: {
    setPost: function setPost(state, _ref8) {
      var post = _ref8.post,
          postId = _ref8.postId;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.items, postId, post);
    }
  }
});

/***/ }),

/***/ "QUa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.forums),function(forum){return _c('ForumListItem',{key:forum['.key'],attrs:{"forum":forum}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RxF9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumList_vue__ = __webpack_require__("9oCC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530f68a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumList_vue__ = __webpack_require__("QUa5");
function injectStyle (ssrContext) {
  __webpack_require__("lbJT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-530f68a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530f68a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TJYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostEditor_vue__ = __webpack_require__("w+/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f441ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostEditor_vue__ = __webpack_require__("JiM8");
function injectStyle (ssrContext) {
  __webpack_require__("ZL4q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28f441ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f441ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UDeV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PostList__ = __webpack_require__("DeYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PostEditor__ = __webpack_require__("TJYQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostList: __WEBPACK_IMPORTED_MODULE_5__components_PostList__["a" /* default */],
    PostEditor: __WEBPACK_IMPORTED_MODULE_6__components_PostEditor__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_asyncDataStatus__["a" /* default */]],

  props: {
    id: {
      required: true,
      type: String
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    authUser: 'auth/authUser'
  }), {
    thread: function thread() {
      return this.$store.state.threads.items[this.id];
    },
    repliesCount: function repliesCount() {
      return this.$store.getters['threads/threadRepliesCount'](this.thread['.key']);
    },
    user: function user() {
      return this.$store.state.users.items[this.thread.userId];
    },
    contributorsCount: function contributorsCount() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* countObjectProperties */])(this.thread.contributors);
    },
    posts: function posts() {
      var postIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.thread.posts);
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.$store.state.posts.items).filter(function (post) {
        return postIds.includes(post['.key']);
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('threads', ['fetchThread']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('users', ['fetchUser']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('posts', ['fetchPosts'])),

  created: function created() {
    var _this = this;

    // fetch thread
    this.fetchThread({ id: this.id }).then(function (thread) {
      // fetch user
      _this.fetchUser({ id: thread.userId });
      return _this.fetchPosts({ ids: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(thread.posts) });
    }).then(function (posts) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(posts.map(function (post) {
        _this.fetchUser({ id: post.userId });
      }));
    }).then(function () {
      _this.asyncDataStatus_fetched();
    });
  }
});

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Usei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validators__ = __webpack_require__("XWRh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: null,
        username: null,
        email: null,
        password: null,
        avatar: null
      }
    };
  },


  validations: {
    form: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      username: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        unique: __WEBPACK_IMPORTED_MODULE_1__utils_validators__["d" /* uniqueUsername */]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"],
        unique: __WEBPACK_IMPORTED_MODULE_1__utils_validators__["c" /* uniqueEmail */]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
      },
      avatar: {
        url: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["url"],
        supportedImageFile: __WEBPACK_IMPORTED_MODULE_1__utils_validators__["b" /* supportedImageFile */],
        responseOk: __WEBPACK_IMPORTED_MODULE_1__utils_validators__["a" /* responseOk */]
      }
    }
  },

  methods: {
    register: function register() {
      var _this = this;

      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.$store.dispatch('auth/registerUserWithEmailAndPassword', this.form).then(function () {
        return _this.successRedirect();
      });
    },
    registerWithGoogle: function registerWithGoogle() {
      var _this2 = this;

      this.$store.dispatch('auth/signInWithGoogle').then(function () {
        return _this2.successRedirect();
      });
    },
    successRedirect: function successRedirect() {
      var redirectTo = this.$route.query.redirectTo || { name: 'Home' };
      this.$router.push(redirectTo);
    }
  },

  created: function created() {
    this.$emit('ready');
  }
});

/***/ }),

/***/ "Vb7x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headingLarge":"_3wvlcmJVfpkFNwvcMtguNQ_0","textLarge":"Lg9t8Jno_pLkEQJ-x3-6P_0","centered":"_1ui25BDQY5yii84g-kSA0G_0"};

/***/ }),

/***/ "VgQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$emit('ready');
  }
});

/***/ }),

/***/ "W9X7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-large push-top"},[_c('h1',[_vm._v(_vm._s(_vm.thread.title)+"\n\n    "),_c('router-link',{staticClass:"btn-green btn-small",attrs:{"to":{name: 'ThreadEdit', id: this.id},"tag":"button"}},[_vm._v("\n      Edit Thread\n    ")])],1),_vm._v(" "),_c('p',[_vm._v("\n    By "),_c('a',{staticClass:"link-unstyled",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(", "),_c('AppDate',{attrs:{"timestamp":_vm.thread.publishedAt}}),_vm._v(".\n    "),_c('span',{staticClass:"hide-mobile text-faded text-small",staticStyle:{"float":"right","margin-top":"2px"}},[_vm._v(_vm._s(_vm.repliesCount)+" replies by "+_vm._s(_vm.contributorsCount)+" contributors")])],1),_vm._v(" "),_c('PostList',{attrs:{"posts":_vm.posts}}),_vm._v(" "),(_vm.authUser)?_c('PostEditor',{attrs:{"threadId":_vm.id}}):_c('div',{staticClass:"text-center",staticStyle:{"margin-bottom":"50px"}},[_c('router-link',{attrs:{"to":{name: 'SignIn', query: {redirectTo: _vm.$route.path}}}},[_vm._v("Sign in")]),_vm._v(" or\n    "),_c('router-link',{attrs:{"to":{name: 'Register', query: {redirectTo: _vm.$route.path}}}},[_vm._v("Register")]),_vm._v(" to post a reply.\n  ")],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wzdu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageRegister_vue__ = __webpack_require__("Usei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211b3985_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageRegister_vue__ = __webpack_require__("c/A7");
function injectStyle (ssrContext) {
  __webpack_require__("Kagk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211b3985"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211b3985_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XWRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uniqueUsername; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedImageFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return responseOk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uniqueEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);




var uniqueUsername = function uniqueUsername(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].req(value)) {
    return true;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users').orderByChild('usernameLower').equalTo(value.toLowerCase()).once('value', function (snapshot) {
      return resolve(!snapshot.exists());
    });
  });
};

var supportedImageFile = function supportedImageFile(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].req(value)) {
    return true;
  }
  var supported = ['jpg', 'jpeg', 'gif', 'png', 'svg'];
  var suffix = value.split('.').pop();
  return supported.includes(suffix);
};

var responseOk = function responseOk(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].req(value)) {
    return true;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    fetch(value).then(function (response) {
      return resolve(response.ok);
    }).catch(function () {
      return resolve(false);
    });
  });
};

var uniqueEmail = function uniqueEmail(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].req(value)) {
    return true;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('users').orderByChild('email').equalTo(value.toLowerCase()).once('value', function (snapshot) {
      return resolve(!snapshot.exists());
    });
  });
};

/***/ }),

/***/ "Y8Jm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"forum-wrapper"},[_c('div',{staticClass:"col-full push-top"},[_c('div',{staticClass:"forum-header"},[_c('div',{staticClass:"forum-details"},[_c('h1',[_vm._v(_vm._s(_vm.forum.name))]),_vm._v(" "),_c('p',{staticClass:"text-lead"},[_vm._v(_vm._s(_vm.forum.description))])]),_vm._v(" "),_c('router-link',{staticClass:"btn-green btn-small",attrs:{"to":{name: 'ThreadCreate', params: {forumId: this.forum['.key']}}}},[_vm._v("\n        Start a thread\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-full push-top"},[_c('ThreadList',{attrs:{"threads":_vm.threads}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YJf6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_PageHome__ = __webpack_require__("zosi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_PageThreadShow__ = __webpack_require__("Ct2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_PageThreadCreate__ = __webpack_require__("3kGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_PageThreadEdit__ = __webpack_require__("2ZPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_PageCategory__ = __webpack_require__("b5o+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_PageForum__ = __webpack_require__("mAT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PageProfile__ = __webpack_require__("ecxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PageRegister__ = __webpack_require__("Wzdu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_PageSignIn__ = __webpack_require__("o9gb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_PageNotFound__ = __webpack_require__("5CYW");













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_PageHome__["a" /* default */]
  }, {
    path: '/category/:id',
    name: 'Category',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_PageCategory__["a" /* default */],
    props: true
  }, {
    path: '/forum/:id',
    name: 'Forum',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_PageForum__["a" /* default */],
    props: true
  }, {
    path: '/thread/create/:forumId',
    name: 'ThreadCreate',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_PageThreadCreate__["a" /* default */],
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/thread/:id',
    name: 'ThreadShow',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_PageThreadShow__["a" /* default */],
    props: true
  }, {
    path: '/thread/:id/edit',
    name: 'ThreadEdit',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_PageThreadEdit__["a" /* default */],
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/me',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_PageProfile__["a" /* default */],
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/me/edit',
    name: 'ProfileEdit',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_PageProfile__["a" /* default */],
    props: { edit: true },
    meta: { requiresAuth: true }
  }, {
    path: '/register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_PageRegister__["a" /* default */],
    meta: { requiresGuest: true }
  }, {
    path: '/signin',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_PageSignIn__["a" /* default */],
    meta: { requiresGuest: true }
  }, {
    path: '/logout',
    name: 'SignOut',
    meta: { requiresAuth: true },
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('signOut').then(function () {
        return next({ name: 'Home' });
      });
    }
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_PageNotFound__["a" /* default */]
  }],
  mode: 'history'
});

router.beforeEach(function (to, from, next) {
  console.log('\uD83D\uDEA6 navigating to ' + to.name + ' from ' + from.name);

  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/initAuthentication').then(function (user) {
    if (to.matched.some(function (route) {
      return route.meta.requiresAuth;
    })) {
      // protected route
      if (user) {
        next();
      } else {
        next({ name: 'SignIn', query: { redirectTo: to.path } });
      }
    } else if (to.matched.some(function (route) {
      return route.meta.requiresGuest;
    })) {
      // protected route
      if (!user) {
        next();
      } else {
        next({ name: 'Home' });
      }
    } else {
      next();
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZH5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "ZL4q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZvBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "awId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__ = __webpack_require__("wEhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadEditor: __WEBPACK_IMPORTED_MODULE_2__components_ThreadEditor__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_asyncDataStatus__["a" /* default */]],

  props: {
    id: {
      type: String,
      required: true
    }
  },

  computed: {
    thread: function thread() {
      return this.$store.state.threads.items[this.id];
    },
    text: function text() {
      var post = this.$store.state.posts.items[this.thread.firstPostId];
      return post ? post.text : null;
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      // this.saved is not required in this implementation because `this.thread.title` and `this.text` are reactive
      // Thus `hasUnsavedChanges` will automatically become false when the thread is updated
      return this.$refs.editor.form.title !== this.thread.title || this.$refs.editor.form.text !== this.text;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('threads', ['updateThread', 'fetchThread']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('posts', ['fetchPost']), {
    save: function save(_ref) {
      var _this = this;

      var title = _ref.title,
          text = _ref.text;

      this.updateThread({
        id: this.id,
        title: title,
        text: text
      }).then(function (thread) {
        _this.$router.push({ name: 'ThreadShow', params: { id: _this.id } });
      });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'ThreadShow', params: { id: this.id } });
    }
  }),

  created: function created() {
    var _this2 = this;

    this.fetchThread({ id: this.id }).then(function (thread) {
      return _this2.fetchPost({ id: thread.firstPostId });
    }).then(function () {
      _this2.asyncDataStatus_fetched();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      var confirmed = window.confirm('Are you sure you want to leave? Any unsaved changes will be lost!');
      if (confirmed) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "b4MN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostListItem__ = __webpack_require__("kqo0");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostListItem: __WEBPACK_IMPORTED_MODULE_0__PostListItem__["a" /* default */]
  },

  props: {
    posts: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "b5o+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageCategory_vue__ = __webpack_require__("MzKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf65bb40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageCategory_vue__ = __webpack_require__("H2uP");
function injectStyle (ssrContext) {
  __webpack_require__("20wD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf65bb40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf65bb40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c/A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid justify-center"},[_c('div',{staticClass:"col-2"},[_c('form',{staticClass:"card card-form",on:{"submit":function($event){$event.preventDefault();_vm.register($event)}}},[_c('h1',{staticClass:"text-center"},[_vm._v("Register")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-input",attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.form.name)},on:{"blur":function($event){_vm.$v.form.name.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.name.$error)?[(!_vm.$v.form.name.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"username"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.form.username),expression:"form.username",modifiers:{"lazy":true}}],staticClass:"form-input",attrs:{"id":"username","type":"text"},domProps:{"value":(_vm.form.username)},on:{"blur":function($event){_vm.$v.form.username.$touch()},"change":function($event){_vm.$set(_vm.form, "username", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.username.$error)?[(!_vm.$v.form.username.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.username.unique)?_c('span',{staticClass:"form-error"},[_vm._v("Sorry! This username is taken")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.form.email),expression:"form.email",modifiers:{"lazy":true}}],staticClass:"form-input",attrs:{"id":"email"},domProps:{"value":(_vm.form.email)},on:{"blur":function($event){_vm.$v.form.email.$touch()},"change":function($event){_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.email.$error)?[(!_vm.$v.form.email.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):(!_vm.$v.form.email.email)?_c('span',{staticClass:"form-error"},[_vm._v("This in not a valid email address")]):(!_vm.$v.form.email.unique)?_c('span',{staticClass:"form-error"},[_vm._v("Sorry! This email is taken")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-input",attrs:{"id":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"blur":function($event){_vm.$v.form.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.password.$error)?[(!_vm.$v.form.password.required)?_c('span',{staticClass:"form-error"},[_vm._v("This field is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.password.minLength)?_c('span',{staticClass:"form-error"},[_vm._v("The password must be at least 6 characters long")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"avatar"}},[_vm._v("Avatar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.form.avatar),expression:"form.avatar",modifiers:{"lazy":true}}],staticClass:"form-input",attrs:{"id":"avatar","type":"text"},domProps:{"value":(_vm.form.avatar)},on:{"blur":function($event){_vm.$v.form.avatar.$touch()},"change":function($event){_vm.$set(_vm.form, "avatar", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.avatar.$error)?[(!_vm.$v.form.avatar.url)?_c('span',{staticClass:"form-error"},[_vm._v("The supplied URL is invalid")]):(!_vm.$v.form.avatar.supportedImageFile)?_c('span',{staticClass:"form-error"},[_vm._v("This file type is not supported by our system. Supported file types: .jpg, .png, .gif, .jpeg, .svg")]):(!_vm.$v.form.avatar.responseOk)?_c('span',{staticClass:"form-error"},[_vm._v("The supplied image cannot be found")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"text-center push-top"},[_c('button',{staticClass:"btn-red btn-xsmall",on:{"click":_vm.registerWithGoogle}},[_c('i',{staticClass:"fa fa-google fa-btn"}),_vm._v("Sign up with Google")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn-blue btn-block",attrs:{"type":"submit"}},[_vm._v("Register")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ecxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageProfile_vue__ = __webpack_require__("nVtz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69b77cb7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageProfile_vue__ = __webpack_require__("FLwn");
function injectStyle (ssrContext) {
  __webpack_require__("jnIV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69b77cb7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69b77cb7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h7FN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-fading-circle"},[_c('div',{staticClass:"sk-circle1 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-circle"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "igFY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iy9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThreadListItem__ = __webpack_require__("oEgK");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadListItem: __WEBPACK_IMPORTED_MODULE_0__ThreadListItem__["a" /* default */]
  },

  props: {
    threads: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "jmvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryListItem__ = __webpack_require__("u7GP");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CategoryListItem: __WEBPACK_IMPORTED_MODULE_0__CategoryListItem__["a" /* default */]
  },

  props: {
    categories: {
      required: true,
      type: Array
    }
  }
});

/***/ }),

/***/ "jnIV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kqo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostListItem_vue__ = __webpack_require__("IqJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c8f0ddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostListItem_vue__ = __webpack_require__("JIjQ");
function injectStyle (ssrContext) {
  __webpack_require__("HcPj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c8f0ddc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c8f0ddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lMYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CategoryList__ = __webpack_require__("rlI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");




//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CategoryList: __WEBPACK_IMPORTED_MODULE_5__components_CategoryList__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_asyncDataStatus__["a" /* default */]],

  computed: {
    categories: function categories() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.$store.state.categories.items);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('categories', ['fetchAllCategories']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('forums', ['fetchForums'])),

  created: function created() {
    var _this = this;

    this.fetchAllCategories().then(function (categories) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(categories.map(function (category) {
        return _this.fetchForums({ ids: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(category.forums) });
      }));
    }).then(function () {
      _this.asyncDataStatus_fetched();
    });
  }
});

/***/ }),

/***/ "lSiE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiPgogICAgPHBvbHlsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzU3QUQ4RCIgc3Ryb2tlLXdpZHRoPSIyIiBwb2ludHM9IjEzOTYuNjQyIDQyLjM0OCAxNDAxLjIyMyA0Ny4zNDggMTQwNi4xNjEgNDIuMzQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTM5NSAtNDEpIi8+Cjwvc3ZnPg=="

/***/ }),

/***/ "lbJT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mAT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageForum_vue__ = __webpack_require__("skxu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95a6ca2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageForum_vue__ = __webpack_require__("Y8Jm");
function injectStyle (ssrContext) {
  __webpack_require__("+QwA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f95a6ca2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageForum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95a6ca2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageForum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  fetchItem: function fetchItem(_ref, _ref2) {
    var state = _ref.state,
        commit = _ref.commit;
    var id = _ref2.id,
        emoji = _ref2.emoji,
        resource = _ref2.resource;

    console.log('🔥‍', emoji, id);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref(resource).child(id).once('value', function (snapshot) {
        commit('setItem', { resource: resource, id: snapshot.key, item: snapshot.val() });
        resolve(state[resource].items[id]);
      });
    });
  },
  fetchItems: function fetchItems(_ref3, _ref4) {
    var dispatch = _ref3.dispatch;
    var ids = _ref4.ids,
        resource = _ref4.resource,
        emoji = _ref4.emoji;

    ids = Array.isArray(ids) ? ids : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ids);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(ids.map(function (id) {
      return dispatch('fetchItem', { id: id, resource: resource, emoji: emoji });
    }));
  }
});

/***/ }),

/***/ "mnTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thread && _vm.user)?_c('div',{staticClass:"thread"},[_c('div',[_c('p',[_c('router-link',{attrs:{"to":{name: 'ThreadShow', params: {id: _vm.thread['.key']}}}},[_vm._v("\n        "+_vm._s(_vm.thread.title)+"\n      ")])],1),_vm._v(" "),_c('p',{staticClass:"text-faded text-xsmall"},[_vm._v("\n      By "),_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(", "),_c('AppDate',{attrs:{"timestamp":_vm.thread.publishedAt}}),_vm._v(".\n    ")],1)]),_vm._v(" "),_c('div',{staticClass:"activity"},[_c('p',{staticClass:"replies-count"},[_vm._v("\n      "+_vm._s(_vm.repliesCount)+" replies\n    ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nJYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_click_outside__ = __webpack_require__("oKYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_handle_scroll__ = __webpack_require__("OGiz");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_2__directives_click_outside__["a" /* default */],
    handleScroll: __WEBPACK_IMPORTED_MODULE_3__directives_handle_scroll__["a" /* default */]
  },

  data: function data() {
    return {
      userDropdownOpen: false,
      mobileNavOpen: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    'user': 'auth/authUser'
  })),

  methods: {
    closeUserDropdown: function closeUserDropdown() {
      this.userDropdownOpen = false;
    },
    closeMobileNavbar: function closeMobileNavbar() {
      this.mobileNavOpen = false;
    }
  }
});

/***/ }),

/***/ "nVtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostList__ = __webpack_require__("DeYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserProfileCard__ = __webpack_require__("137Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UserProfileCardEditor__ = __webpack_require__("vA19");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostList: __WEBPACK_IMPORTED_MODULE_1__components_PostList__["a" /* default */],
    UserProfileCard: __WEBPACK_IMPORTED_MODULE_2__components_UserProfileCard__["a" /* default */],
    UserProfileCardEditor: __WEBPACK_IMPORTED_MODULE_3__components_UserProfileCardEditor__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__["a" /* default */]],

  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'auth/authUser'
  }), {
    userPosts: function userPosts() {
      return this.$store.getters['users/userPosts'](this.user['.key']);
    }
  }),
  created: function created() {
    var _this = this;

    var posts = this.user && this.user.posts ? this.user.posts : [];
    this.$store.dispatch('posts/fetchPosts', { ids: posts }).then(function () {
      return _this.asyncDataStatus_fetched();
    });
  }
});

/***/ }),

/***/ "o9gb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSignIn_vue__ = __webpack_require__("wsDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bb68cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSignIn_vue__ = __webpack_require__("+i8h");
function injectStyle (ssrContext) {
  __webpack_require__("ylSs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bb68cb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bb68cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oEgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadListItem_vue__ = __webpack_require__("pPvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d352d88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__ = __webpack_require__("mnTS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d352d88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oKYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    el.__ClickOutsideHandler__ = function (event) {
      // check if event's target is the el or contained by el
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.body.addEventListener('click', el.__ClickOutsideHandler__);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.__ClickOutsideHandler__);
  }
});

/***/ }),

/***/ "pPvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    thread: {
      required: true,
      type: Object
    }
  },

  computed: {
    repliesCount: function repliesCount() {
      return this.$store.getters['threads/threadRepliesCount'](this.thread['.key']);
    },
    user: function user() {
      return this.$store.state.users.items[this.thread.userId];
    }
  }
});

/***/ }),

/***/ "pUFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.categories),function(category){return _c('CategoryListItem',{key:category['.key'],attrs:{"category":category}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rQVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    timestamp: {
      required: true,
      type: Number
    }
  },

  filters: {
    humanFriendlyDate: function humanFriendlyDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    diffForHumans: function diffForHumans(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(date).fromNow();
    }
  }
});

/***/ }),

/***/ "rlI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__ = __webpack_require__("jmvG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8a8be86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__ = __webpack_require__("pUFW");
function injectStyle (ssrContext) {
  __webpack_require__("2Puu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8a8be86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8a8be86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sZvr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.save($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"thread_title"}},[_vm._v("Title:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-input",attrs:{"type":"text","id":"thread_title","name":"title"},domProps:{"value":(_vm.form.title)},on:{"blur":function($event){_vm.$v.form.title.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.title.$error)?[(!_vm.$v.form.title.required)?_c('span',{staticClass:"form-error"},[_vm._v("Thread must have a title")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.title.minLength)?_c('span',{staticClass:"form-error"},[_vm._v("The title must be least 10 characters long")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"thread_content"}},[_vm._v("Content:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.text),expression:"form.text"}],staticClass:"form-input",attrs:{"id":"thread_content","name":"content","rows":"8","cols":"140"},domProps:{"value":(_vm.form.text)},on:{"blur":function($event){_vm.$v.form.text.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "text", $event.target.value)}}}),_vm._v(" "),(_vm.$v.form.text.$error)?[(!_vm.$v.form.text.required)?_c('span',{staticClass:"form-error"},[_vm._v("Thread must have some content")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.text.minLength)?_c('span',{staticClass:"form-error"},[_vm._v("The text of the thread must be least 40 characters long. Type at least "+_vm._s(40 - _vm.form.text.length)+" more")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-ghost",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-blue",attrs:{"type":"submit","name":"Publish"}},[_vm._v(_vm._s(_vm.isUpdate ? 'Update' : 'Publish'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "skxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ThreadList__ = __webpack_require__("COEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__ = __webpack_require__("2aZJ");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadList: __WEBPACK_IMPORTED_MODULE_4__components_ThreadList__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_asyncDataStatus__["a" /* default */]],

  props: {
    id: {
      required: true,
      type: String
    }
  },

  computed: {
    forum: function forum() {
      return this.$store.state.forums.items[this.id];
    },
    threads: function threads() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.$store.state.threads.items).filter(function (thread) {
        return thread.forumId === _this.id;
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('forums', ['fetchForum']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('threads', ['fetchThreads']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('users', ['fetchUser'])),

  created: function created() {
    var _this2 = this;

    this.fetchForum({ id: this.id }).then(function (forum) {
      return _this2.fetchThreads({ ids: forum.threads });
    }).then(function (threads) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(threads.map(function (thread) {
        return _this2.fetchUser({ id: thread.userId });
      }));
    }).then(function () {
      _this2.asyncDataStatus_fetched();
    });
  }
});

/***/ }),

/***/ "u7GP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryListItem_vue__ = __webpack_require__("3YjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7023f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryListItem_vue__ = __webpack_require__("BigJ");
function injectStyle (ssrContext) {
  __webpack_require__("DMjY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f7023f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7023f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  setItem: function setItem(state, _ref) {
    var item = _ref.item,
        id = _ref.id,
        resource = _ref.resource;

    item['.key'] = id;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state[resource].items, id, item);
  }
});

/***/ }),

/***/ "upVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_assetHelpers__ = __webpack_require__("7n+g");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    fetchForum: function fetchForum(_ref, _ref2) {
      var dispatch = _ref.dispatch;
      var id = _ref2.id;
      return dispatch('fetchItem', { resource: 'forums', id: id, emoji: '🌧' }, { root: true });
    },
    fetchForums: function fetchForums(_ref3, _ref4) {
      var dispatch = _ref3.dispatch;
      var ids = _ref4.ids;
      return dispatch('fetchItems', { resource: 'forums', ids: ids, emoji: '🌧' }, { root: true });
    }
  },

  mutations: {
    appendThreadToForum: Object(__WEBPACK_IMPORTED_MODULE_0__store_assetHelpers__["a" /* makeAppendChildToParentMutation */])({ parent: 'forums', child: 'threads' })
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vA19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCardEditor_vue__ = __webpack_require__("/7IL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfffbf2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCardEditor_vue__ = __webpack_require__("28xs");
function injectStyle (ssrContext) {
  __webpack_require__("2IqW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfffbf2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfileCardEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfffbf2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfileCardEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w+/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    threadId: {
      required: false
    },

    post: {
      type: Object,
      validator: function validator(obj) {
        var keyIsValid = typeof obj['.key'] === 'string';
        var textIsValid = typeof obj.text === 'string';
        var valid = keyIsValid && textIsValid;
        if (!textIsValid) {
          console.error('😳 The post prop object must include a `text` attribute.');
        }
        if (!keyIsValid) {
          console.error('😳 The post prop object must include a `.key` attribute.');
        }
        return valid;
      }
    }
  },

  data: function data() {
    return {
      text: this.post ? this.post.text : ''
    };
  },


  computed: {
    isUpdate: function isUpdate() {
      return !!this.post;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('posts', ['createPost', 'updatePost']), {
    save: function save() {
      var _this = this;

      this.persist().then(function (post) {
        _this.$emit('save', { post: post });
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    create: function create() {
      var post = {
        text: this.text,
        threadId: this.threadId
      };
      this.text = '';

      return this.createPost(post);
    },
    update: function update() {
      var payload = {
        id: this.post['.key'],
        text: this.text
      };
      return this.updatePost(payload);
    },
    persist: function persist() {
      return this.isUpdate ? this.update() : this.create();
    }
  })
});

/***/ }),

/***/ "wEhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadEditor_vue__ = __webpack_require__("NMPn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6d996d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadEditor_vue__ = __webpack_require__("sZvr");
function injectStyle (ssrContext) {
  __webpack_require__("Eu5h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6d996d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6d996d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wSRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSpinner_vue__ = __webpack_require__("ZH5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3984aef9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSpinner_vue__ = __webpack_require__("h7FN");
function injectStyle (ssrContext) {
  __webpack_require__("91W5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3984aef9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3984aef9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wsDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        email: null,
        password: null
      }
    };
  },


  validations: {
    form: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
      }
    }
  },

  methods: {
    signIn: function signIn() {
      var _this = this;

      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.$store.dispatch('auth/signInWithEmailAndPassword', {
          email: this.form.email,
          password: this.form.password
        }).then(function () {
          return _this.successRedirect();
        }).catch(function (error) {
          return alert('🤷‍️' + error.message);
        });
      }
    },
    signInWithGoogle: function signInWithGoogle() {
      var _this2 = this;

      this.$store.dispatch('auth/signInWithGoogle').then(function () {
        return _this2.successRedirect();
      }).catch(function (error) {
        return alert('🤷‍️' + error.message);
      });
    },
    successRedirect: function successRedirect() {
      var redirectTo = this.$route.query.redirectTo || { name: 'Home' };
      this.$router.push(redirectTo);
    }
  },

  created: function created() {
    this.$emit('ready');
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheNavbar__ = __webpack_require__("9TRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppSpinner__ = __webpack_require__("wSRz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TheNavbar: __WEBPACK_IMPORTED_MODULE_0__components_TheNavbar__["a" /* default */],
    AppSpinner: __WEBPACK_IMPORTED_MODULE_1__components_AppSpinner__["a" /* default */]
  },

  data: function data() {
    return {
      showPage: false
    };
  },


  methods: {
    pageReady: function pageReady() {
      this.showPage = true;
      __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
    }
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.configure({
      speed: 200,
      showSpinner: false
    });
    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start();
    this.$router.beforeEach(function (to, from, next) {
      _this.showPage = false;
      __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start();
      next();
    });
  }
});

/***/ }),

/***/ "xSZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_assetHelpers__ = __webpack_require__("7n+g");







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    items: {}
  },

  getters: {
    userPosts: function userPosts(state, getters, rootState) {
      return function (id) {
        var user = state.items[id];
        if (user.posts) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(rootState.posts.items).filter(function (post) {
            return post.userId === id;
          });
        }
        return [];
      };
    },

    userThreadsCount: function userThreadsCount(state) {
      return function (id) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* countObjectProperties */])(state.items[id].threads);
      };
    },
    userPostsCount: function userPostsCount(state) {
      return function (id) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* countObjectProperties */])(state.items[id].posts);
      };
    }
  },

  actions: {
    createUser: function createUser(_ref, _ref2) {
      var state = _ref.state,
          commit = _ref.commit;
      var id = _ref2.id,
          email = _ref2.email,
          name = _ref2.name,
          username = _ref2.username,
          _ref2$avatar = _ref2.avatar,
          avatar = _ref2$avatar === undefined ? null : _ref2$avatar;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var registeredAt = Math.floor(Date.now() / 1000);
        var usernameLower = username.toLowerCase();
        email = email.toLowerCase();
        var user = { avatar: avatar, email: email, name: name, username: username, usernameLower: usernameLower, registeredAt: registeredAt };
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('users').child(id).set(user).then(function () {
          commit('setItem', { resource: 'users', id: id, item: user }, { root: true });
          resolve(state.items[id]);
        });
      });
    },
    updateUser: function updateUser(_ref3, user) {
      var commit = _ref3.commit;

      var updates = {
        avatar: user.avatar,
        username: user.username,
        name: user.name,
        bio: user.bio,
        website: user.website,
        email: user.email,
        location: user.location
      };
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('users').child(user['.key']).update(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* removeEmptyProperties */])(updates)).then(function () {
          commit('setUser', { userId: user['.key'], user: user });
          resolve(user);
        });
      });
    },


    fetchUser: function fetchUser(_ref4, _ref5) {
      var dispatch = _ref4.dispatch;
      var id = _ref5.id;
      return dispatch('fetchItem', { resource: 'users', id: id, emoji: '🙋' }, { root: true });
    },
    fetchUsers: function fetchUsers(_ref6, _ref7) {
      var dispatch = _ref6.dispatch;
      var ids = _ref7.ids;
      return dispatch('fetchItems', { resource: 'users', ids: ids, emoji: '🙋' }, { root: true });
    }
  },

  mutations: {
    setUser: function setUser(state, _ref8) {
      var user = _ref8.user,
          userId = _ref8.userId;

      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.items, userId, user);
    },


    appendPostToUser: Object(__WEBPACK_IMPORTED_MODULE_5__store_assetHelpers__["a" /* makeAppendChildToParentMutation */])({ parent: 'users', child: 'posts' }),
    appendThreadToUser: Object(__WEBPACK_IMPORTED_MODULE_5__store_assetHelpers__["a" /* makeAppendChildToParentMutation */])({ parent: 'users', child: 'threads' })
  }
});

/***/ }),

/***/ "ylSs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zosi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHome_vue__ = __webpack_require__("lMYB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffb2127e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHome_vue__ = __webpack_require__("1U+8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffb2127e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6e643c8dbccfa40450f9.js